import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../../../api/http";
import userapiservice from "../../../../api/userapiservice";
import { useMediaQuery } from "react-responsive";
import Loader from "../../../../components/Loader/Loader";
import ToastComponent from "../../../../components/ToastCompoent/ToastComponent";
import "./ourTeam.scss";
import { useSelector } from "react-redux";
// import ytPlayBtn from "../../../../assets/images/YouTube_play_button.svg"
import ytPlayBtn from '../../../../assets/newImages/Play.svg';
import ModalPlayer from "../../../../components/PlayerModal/playerModal";
import SynthesiaImage from '../../../../assets/newImages/synthesia.jpg'
import { getYouTubeVideoId, sortDataByOrder } from '../../../../utils/helper';


export default function OurTeam({ activeKey }) {
    const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });
    const localData = useSelector((state) => state?.localStorage)
    const { micrositeID, tabConfigId } = localData
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);
    const id = micrositeID;



    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [mediatype, setmediatype] = useState("");
    const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];


    const getAboutData = async (activeKey, id) => {
        try {
            setLoading(true);
            if (id) {
                const response = await getRequest(
                    userapiservice.getAboutUsDetailsTabs(id, activeKey, tabConfigId),
                    null,
                    false
                );
                setResponseData(sortDataByOrder(response) ?? []);
                setLoading(false);
            }
        } catch (error) {
            toast.error(<ToastComponent type={'Error'} message={error?.error || 'Sorry, Something went wrong'} />)
            setLoading(false);
        }
    };

    const onCardClickHandler = (data) => {
        navigate(`/microsite/${data.id}/micrositeDetails`, {
            state: { page: activeKey, data: data },
        });
    };

    useEffect(() => {
        if (activeKey && id) {
            getAboutData(activeKey, id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const PlayVideoHandler = (url, mediaType) => {
        setmediatype(mediaType)
        setVideoUrl(url);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setVideoUrl("");
    };

    const extractSynthesiaId = (url) => {
        const match = url.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
        return match ? match[0] : null;
    };

    if (loading) {
        return (
            <Loader />
        )
    } else {
        return (
            <div className="our-team-container">
                <div className="card-container">
                    {responseData && responseData.length > 0
                        ?
                        responseData.map((data, i) => {
                            return (
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.5 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{
                                        duration: 0.8,
                                        delay: 0.5,
                                        ease: [0, 0.71, 0.2, 1.01],
                                    }}
                                    className="card-item"
                                    key={data.id}
                                    onClick={() => {
                                        onCardClickHandler({
                                            ...data, description: data.aboutUsTeamDataOutPut.bio,
                                            mediaLink: data.aboutUsTeamDataOutPut.image
                                        });
                                    }}
                                >
                                    {isSmallScreen && (
                                        <div className="card-title" >
                                            {/* {data?.aboutUsTeamDataOutPut?.linkedin} */}
                                            {data?.title ? data?.title : activeKey === 'OUR_TEAM' ? 'Our Team' : 'Our Clients'}
                                        </div>
                                    )}
                                    <div className="text-container"   >
                                        {!isSmallScreen && (
                                            <div className="card-title" >
                                                {/* {data?.aboutUsTeamDataOutPut?.linkedin} */}
                                                {data?.title ? data?.title : activeKey === 'OUR_TEAM' ? 'Our Team' : 'Our Clients'}
                                            </div>
                                        )}
                                        <p className="card-description">

                                            {data?.aboutUsTeamDataOutPut?.bio}
                                        </p>

                                    </div>
                                    <div className="image-container" onClick={() => {
                                        if (data?.webLink) { window.open(data?.webLink, "_blank") }
                                    }} >

                                        {data?.aboutUsTeamDataOutPut?.image?.mediaType === "SOCIAL_MEDIA" &&
                                            data?.aboutUsTeamDataOutPut?.image?.url ? (
                                            (() => {
                                                const videoID = getYouTubeVideoId(data?.aboutUsTeamDataOutPut?.image?.url);
                                                if (!videoID) return null;

                                                return (
                                                    <div
                                                        className="media vimeo youtube"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            PlayVideoHandler(
                                                                `https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0`,
                                                                data?.aboutUsTeamDataOutPut?.image?.mediaType
                                                            );
                                                        }}

                                                    >
                                                        <div style={{ position: "relative" }}>
                                                            <img
                                                                src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                                                                alt="YouTube Video"
                                                                className="vimeo-video-preview-image video-preview-image"
                                                            />
                                                            <img
                                                                className="ytBtnOverlay"
                                                                src={ytPlayBtn}
                                                                alt="Play Button"
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })()
                                        ) : data?.aboutUsTeamDataOutPut?.image?.mediaType === "VIMEO_MEDIA" &&
                                            data?.aboutUsTeamDataOutPut?.image?.url ? (
                                            <div
                                                className="media vimeo youtube"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    PlayVideoHandler(
                                                        data?.aboutUsTeamDataOutPut?.image?.url,
                                                        data?.aboutUsTeamDataOutPut?.image?.mediaType
                                                    );
                                                }}

                                            >
                                                <img
                                                    src={`https://vumbnail.com/${data?.aboutUsTeamDataOutPut?.image?.url?.split("/")[4]
                                                        }.jpg`}
                                                    className="vimeo-video-preview-image video-preview-image"
                                                    alt="Vimeo Preview"
                                                />
                                                <img
                                                    className="ytBtnOverlay"
                                                    src={ytPlayBtn}
                                                    alt="Play Button"
                                                />
                                            </div>


                                        ) :
                                            data?.aboutUsTeamDataOutPut?.image?.mediaType === "SYNTHESIA_MEDIA" &&
                                                data?.aboutUsTeamDataOutPut?.image?.url ? (
                                                (() => {
                                                    const videoId = extractSynthesiaId(data?.aboutUsTeamDataOutPut?.image?.url);
                                                    if (!videoId) return null;


                                                    return (
                                                        <div
                                                            className="media vimeo youtube"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                PlayVideoHandler(
                                                                    `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
                                                                    data?.aboutUsTeamDataOutPut?.image?.mediaType
                                                                );
                                                            }}

                                                        >
                                                            <div style={{ position: "relative" }}>
                                                                {/* Use a placeholder thumbnail */}
                                                                <img
                                                                    src={data?.aboutUsTeamDataOutPut?.image?.thumbnailUrl || SynthesiaImage}
                                                                    alt="Synthesia Video"
                                                                    className="vimeo-video-preview-image video-preview-image"
                                                                />
                                                                <img
                                                                    className="ytBtnOverlay"
                                                                    src={ytPlayBtn}
                                                                    alt="Play Button"
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })()
                                            )
                                                : data?.aboutUsTeamDataOutPut?.image?.mediaType === "IMAGE" || data?.aboutUsTeamDataOutPut?.image?.mediaType === "GIF" ? (
                                                    <div className={activeKey === "OUR_TEAM" ?
                                                        data?.aboutUsTeamDataOutPut?.image?.mediaType === "GIF" ? '' : "imagesection1"
                                                        : ""
                                                    }>
                                                        <img
                                                            src={data?.aboutUsTeamDataOutPut?.image?.url}
                                                            className="preview-img"
                                                            alt=""
                                                            onClick={() => {
                                                                onCardClickHandler(data);
                                                            }}
                                                        />
                                                    </div>

                                                ) : <div style={{ height: "100%" }}></div>}

                                    </div>
                                    <div className="color-band" style={{ backgroundColor: color[i] }} />
                                </motion.div>
                            );
                        })
                        : <div className="info-container" > Nothing here at the moment </div>}
                </div>

                {isModalOpen ? (
                    <ModalPlayer
                        closeModal={handleCancel}
                        mediaLink={videoUrl}
                        mediaType={mediatype}
                    />
                ) : (
                    ""
                )}
            </div >
        );
    }
}
